import type { CountryRequiresWhatsappStatusGetResultAjax } from './country-requires-whatsapp.backend-model';
import type { CountryRequiresWhatsappStatus } from './country-requires-whatsapp.model';

export function transformCountryRequiresWhatsappStatus(
  countryRequiresWhatsappStatus: CountryRequiresWhatsappStatusGetResultAjax,
  countryCode: string,
): CountryRequiresWhatsappStatus {
  return {
    id: countryCode,
    countryRequiresWhatsapp:
      countryRequiresWhatsappStatus.countryRequiresWhatsapp,
    countryOffersWhatsapp: countryRequiresWhatsappStatus.countryOffersWhatsapp,
  };
}
